import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function MotorTypes() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingImg, setUploadingImg] = useState(false);
  const [form, setForm] = useState({ name: '', image_url: '', display_order: 0 });

  const fetchTypes = async () => {
    setLoading(true);
    try {
      const res = await api.get('/motor-types/admin/all');
      setTypes(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== 'image/png') {
      alert('File wajib format PNG');
      e.target.value = '';
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('Ukuran maksimal 5MB');
      e.target.value = '';
      return;
    }
    setUploadingImg(true);
    try {
      const fd = new FormData();
      fd.append('photo', file);
      const res = await api.post('/upload/motor-type-logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm((f) => ({ ...f, image_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload gambar');
    } finally {
      setUploadingImg(false);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.image_url) {
      alert('Nama dan gambar PNG wajib diisi');
      return;
    }
    setSaving(true);
    try {
      await api.post('/motor-types', form);
      setForm({ name: '', image_url: '', display_order: 0 });
      fetchTypes();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal tambah tipe motor');
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async (t) => {
    try {
      await api.put(`/motor-types/${t.id}`, { is_active: !t.is_active });
      fetchTypes();
    } catch (err) {
      alert('Gagal update status');
    }
  };

  const updateOrder = async (t, newOrder) => {
    try {
      await api.put(`/motor-types/${t.id}`, { display_order: newOrder });
      fetchTypes();
    } catch (err) {
      alert('Gagal update urutan');
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Hapus tipe motor "${name}"? Member yang lagi pakai tipe ini bakal jadi "belum pilih tipe" otomatis.`)) return;
    try {
      await api.delete(`/motor-types/${id}`);
      fetchTypes();
    } catch (err) {
      alert('Gagal hapus tipe motor');
    }
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%' };

  return (
    <Layout>
      <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Kelola Tipe Motor</h1>

      <form onSubmit={handleAdd} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 20, marginBottom: 24, maxWidth: 480 }}>
        <h2 style={{ fontSize: 16, fontWeight: 800, marginBottom: 14 }}>Tambah Tipe Motor</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Nama Tipe</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Contoh: Trail" style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Urutan Tampil</label>
            <input type="number" value={form.display_order} onChange={(e) => setForm({ ...form, display_order: Number(e.target.value) })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Gambar (wajib PNG transparan)</label>
            {form.image_url && (
              <div style={{ width: 100, height: 100, background: '#12151A', borderRadius: 6, marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={form.image_url} alt="" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              </div>
            )}
            <label style={{ display: 'inline-block', background: '#262b33', color: '#F0EDE4', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>
              {uploadingImg ? 'Mengupload...' : 'Upload PNG'}
              <input type="file" accept="image/png" onChange={handleImageUpload} style={{ display: 'none' }} />
            </label>
            <p style={{ fontSize: 10, color: '#5a616e', marginTop: 4 }}>Wajib PNG, maks 5MB. Pakai background transparan biar konsisten.</p>
          </div>
          <button type="submit" disabled={saving} style={{ background: '#D02127', color: '#fff', border: 'none', padding: 12, borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
            {saving ? 'Menyimpan...' : 'Tambah Tipe Motor'}
          </button>
        </div>
      </form>

      <h2 style={{ fontSize: 16, fontWeight: 800, marginBottom: 14 }}>Daftar Tipe Motor</h2>
      {loading ? (
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      ) : types.length === 0 ? (
        <p style={{ color: '#8B92A0' }}>Belum ada tipe motor.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 14 }}>
          {types.map((t) => (
            <div key={t.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 14, opacity: t.is_active ? 1 : 0.5 }}>
              <div style={{ width: '100%', height: 90, background: '#12151A', borderRadius: 6, marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={t.image_url} alt={t.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              </div>
              <p style={{ fontWeight: 700, fontSize: 13 }}>{t.name}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
                <span style={{ fontSize: 11, color: '#8B92A0' }}>Urutan:</span>
                <input
                  type="number"
                  defaultValue={t.display_order}
                  onBlur={(e) => updateOrder(t, Number(e.target.value))}
                  style={{ width: 50, background: '#12151A', border: '1px solid #262b33', color: '#F0EDE4', padding: '3px 6px', borderRadius: 4, fontSize: 11 }}
                />
              </div>
              <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <button
                  onClick={() => toggleActive(t)}
                  style={{
                    flex: 1, background: t.is_active ? 'rgba(74,222,128,0.15)' : 'rgba(139,146,160,0.15)',
                    color: t.is_active ? '#4ADE80' : '#8B92A0', border: 'none', padding: '6px 0', borderRadius: 4, fontSize: 11, fontWeight: 700, cursor: 'pointer',
                  }}
                >
                  {t.is_active ? 'Aktif' : 'Nonaktif'}
                </button>
                <button
                  onClick={() => handleDelete(t.id, t.name)}
                  style={{ flex: 1, background: 'rgba(208,33,39,0.15)', color: '#D02127', border: 'none', padding: '6px 0', borderRadius: 4, fontSize: 11, fontWeight: 700, cursor: 'pointer' }}
                >
                  Hapus
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
